import { menuDetailQuery } from '@/graphql/query/menuDetailQuery'
import { callGraphQlClient } from '../loaderGraphQl'
import { getOrderItemHash } from '@/ui/components/cart/helper'
import { captureException } from '@sentry/nextjs'
import { menuCompleteDetailQuery } from '@/graphql/query/menuCompleteDetailQuery'

export const loadMenu = async (branchId, dispatch) => {
    const variables = {
        branchId: branchId
    }
    const speedloData = await callGraphQlClient(menuDetailQuery, variables, dispatch).catch(err => {
        captureException(err)
        console.error(err)
    })
    if (speedloData) speedloData.tags = setupMenu(speedloData)
    return speedloData
}

function setupMenu(data) {
    const { wareCategories } = data

    let collectedTags = []
    //  Create unique tags
    wareCategories.flatMap(category => {
        let recipeUnique = []
        category.recipes.flatMap(recipe => {
            recipeUnique.push([...new Map(recipe.recipeTags.map(item => [item['id'], item])).values()])
        })
        collectedTags.push(recipeUnique)
    })

    let uniqueTags = []
    for (let i = 0; i < collectedTags.length; i++) {
        let collectedElements = [...new Set(collectedTags[i].flat(1))]
        for (let collectedElement of collectedElements) {
            const found = uniqueTags.some(tag => tag.id === collectedElement.id)
            if (!found) uniqueTags.push(collectedElement)
        }
    }

    uniqueTags.sort((item, item2) => {
        return item.label.localeCompare(item2.label)
    })

    return uniqueTags
}

export async function completeMenu(uniqueTags, branchId, dispatch) {
    const variables = {
        branchId: branchId
    }

    const speedloData = await callGraphQlClient(menuCompleteDetailQuery, variables, dispatch).catch(err => {
        captureException(err)
        console.error(err)
    })

    const { wareCategories } = speedloData

    // Assign categories to tags
    for (let x = 0; x < uniqueTags.length; x++) {
        let categories = []
        for (let i = 0; i < wareCategories.length; i++) {
            let recipes = []
            for (let j = 0; j < wareCategories[i].recipes.length; j++) {
                for (let k = wareCategories[i].recipes[j].recipeTags.length - 1; k >= 0; k--) {
                    if (uniqueTags[x].id === wareCategories[i].recipes[j].recipeTags[k].id) {
                        let recipe = {}
                        const props = Object.keys(wareCategories[i].recipes[j])
                        for (let l = 0; l < props.length; l++) {
                            if (props[l] !== 'recipeTags') recipe[props[l]] = wareCategories[i].recipes[j][props[l]]
                        }
                        recipes.push(recipe)
                    }
                }
            }
            if (recipes.length !== 0) {
                categories.push({
                    id: wareCategories[i].id,
                    nameLabel: wareCategories[i].nameLabel,
                    recipes: recipes
                })
            }
        }
        uniqueTags[x].categories = categories

        uniqueTags.sort((item, item2) => {
            return item.label.localeCompare(item2.label)
        })
    }
    return uniqueTags
}

/*
 *  Filters order items and collect only unique one and sort them alphabetically
 * */
export function getUniqueItems(items) {
    const arrayUniqueByKey = [...new Map(items.map(item => [getOrderItemHash(item), item])).values()]

    arrayUniqueByKey.map(unique => {
        unique.count = items
            .filter(item => {
                return getOrderItemHash(unique) === getOrderItemHash(item)
            })
            .map(item => {
                return item.id
            }).length
    })
    arrayUniqueByKey.sort((item, item2) => {
        if (item.recipe.nameLabel.localeCompare(item2.recipe.nameLabel)) return 1
        else return -1
    })
    return arrayUniqueByKey
}
